import { useEffect, useRef } from "react";
import { session } from "../auth/session";
import { DESKTOP_SIGN_IN, desktop, isDesktop } from "./desktop";

// The desktop app's half of sign-in: every "Sign in" goes through signIn
// (auth/session.ts), which in the app raises DESKTOP_SIGN_IN; this opens the
// system browser and starts the session with the tokens it brings back, as
// the sign-in hash does on the website. Then the page loads again, so
// settleProfile and settlePreferences (main.tsx) make the saves and settings
// the account's, as after a return from the sign-in site.
export default function DesktopSignIn() {
  const running = useRef(false);

  useEffect(() => {
    if (!isDesktop) return;
    const onSignIn = () => {
      if (running.current) return;
      running.current = true;
      desktop
        .signIn()
        // Stored before the reload, which reads them back.
        .then((tokens) => session.signIn(tokens))
        .then(() => window.location.reload())
        .catch((e: unknown) => console.error("sign-in:", e))
        .finally(() => {
          running.current = false;
        });
    };
    window.addEventListener(DESKTOP_SIGN_IN, onSignIn);
    return () => window.removeEventListener(DESKTOP_SIGN_IN, onSignIn);
  }, []);

  return null;
}
